import React, { useContext } from "react";
import { MenuContext } from "../contexts/MenuContext";
import SongDisplayHeader from "./SongDisplayHeader";
import "./styles/SongDisplay.css";
import DOMPurify from "dompurify";

function SongDisplay() {
  const { openSong, setOpenSong } = useContext(MenuContext);

  const sanitizedData = () => ({
    __html: DOMPurify.sanitize(openSong[0].lyrics),
  });

  return (
    <div className="song--display--container">
      <SongDisplayHeader />
      <div className="song--display--body">
        <article>
          <h1>{openSong[0].title}</h1>
          <span className="sep">VERSE I</span>
          <p dangerouslySetInnerHTML={sanitizedData()}></p>
        </article>
      </div>
    </div>
  );
}

export default SongDisplay;
